<template>
  <div class="reportoutdoorloc">
    <v-container>
      <h2>Report my outdoor location</h2>
      <p class="caption">
        I authorize Active Indoors to collect my outdoor GPS location to do
        contact tracing.
      </p>
      <p>Latitude: {{ lat }}</p>
      <p>Longitude: {{ lng }}</p>
      <v-btn
        :loading="loading3"
        :disabled="loading3"
        @click="loader = 'loading3'"
      >
        Report My Location
      </v-btn>
      <p v-if="warning">{{ warning }}</p>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loader: null,
      loading3: false,
      lat: 0,
      lng: 0,
      warning: null,
    };
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      //   setTimeout(() => (this[l] = false), 3000);
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((pos) => {
          this.lat = pos.coords.latitude;
          this.lng = pos.coords.longitude;

          if (this.lat) {
            console.log("ok");
            this[l] = false;
          }

          this.loader = null;
        });
      } else {
        this.warning =
          "Sorry your browser does not support GPS, please contact your administrator.";
      }
    },
  },
  methods: {
    reportMyOutdoorLoc: function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((pos) => {
          this.lat = pos.coords.latitude;
          this.lng = pos.coords.longitude;
        });
      } else {
        this.warning =
          "Sorry your browser does not support GPS, please contact your administrator.";
      }
    },
  },
};
</script>


<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>